<template>
  <div class="adduser">
    <el-dialog :visible.sync="addVisible" title="添加账号" width="500px" :show-close="false" top="10vh">
      <div slot="title">
        <p>添加账号</p>
        <i class="el-icon-error" @click="addVisible = false" style="cursor:pointer"></i>
      </div>
      <el-form :model="userForm" :rules="rules" ref="userForm" label-position="top">
        <el-form-item prop="roleId" label="角色类型：">
          <el-select v-model="userForm.roleId" placeholder="请选择角色类型" @change="changeRole">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="deptId" label="所属部门：">
          <el-select v-model="userForm.deptId" placeholder="请选择所属部门" @change="changebranch">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.deptName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="unitId" label="所属单位：" v-if="userForm.roleId!==1">
          <el-cascader
            v-model="userForm.unitId"
            @change="handleChange"
            :options="options"
            :props="optionProps"
            placeholder="请选择单位"
          ></el-cascader>
        </el-form-item>-->
        <el-form-item prop="userName" label="用户名：">
          <el-input v-model="userForm.userName" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码：">
          <el-input v-model="userForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="certNo" label="执法证号：">
          <el-input v-model="userForm.certNo" placeholder="请输入执法证号"></el-input>
        </el-form-item>
        <el-form-item prop="realName" label="真实姓名：">
          <el-input v-model="userForm.realName" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="手机号：">
          <el-input v-model="userForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <!-- <el-form-item>
        <div class="dialogBtn">
          <el-button @click="addVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm()">确定</el-button>
        </div>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialogBtn">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addUser
  //  addlogoperate
} from "../../axios/api.js";

export default {
  data() {
    return {
      addVisible: false,
      branchList: [
        {
          createTime: "2023-02-17 13:38:02",
          id: 1,
          roleKey: "SUPPER",
          roleName: "监督一科",
          updateTime: "2023-02-17 13:38:02"
        },
        {
          createTime: "2023-02-17 13:38:02",
          id: 2,
          roleKey: "SUPPER1",
          roleName: "监督二科",
          updateTime: "2023-02-17 13:38:02"
        },
        {
          createTime: "2023-02-17 13:38:02",
          id: 3,
          roleKey: "SUPPER2",
          roleName: "监督三科",
          updateTime: "2023-02-17 13:38:02"
        }
      ],
      userForm: {
        roleId: "",
        userName: "",
        password: "",
        realName: "",
        phone: "",
        email: "",
        unitId: "",
        certNo: ""
      },
      rules: {
        roleId: [
          { required: true, message: "请选择角色类型", trigger: "change" }
        ],
        // unitId: [
        //   { required: true, message: "请选择所属单位", trigger: "change" }
        // ],
        userName: [
          {
            required: true,
            validator: this.$validator.username,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: this.$validator.password,
            trigger: "blur"
          }
        ],
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        phone: [
          { required: true, validator: this.$validator.phone, trigger: "blur" }
        ],
        email: [
          {
            required: true,
            validator: this.$validator.email,
            trigger: "blur"
          }
        ]
      },
      options: [],
      roleList: [],
      optionProps: {
        value: "adcode",
        label: "name",
        checkStrictly: true
      }
    };
  },
  mounted() {},
  methods: {
    openVisible(val, options) {
      console.log(options);
      var arr = {};
      for (var i in val) {
        arr[val[i].id] = val[i].name;
      }
      console.log(arr);
      this.roleoption = arr;
      this.addVisible = true;
      this.roleList = val;
      this.deptList = options;
    },

    //选择部门
    changebranch(val) {
      console.log(val);
      this.userForm.deptId = val;
      console.log(this.userForm.deptId);
    },

    // 选择角色
    changeRole(val) {
      console.log(val);
      this.userForm.roleId = val;
      if (val === 1) {
        this.userForm.unitId = undefined;
      }
      console.log(this.userForm.roleId);
    },

    handleChange(value) {
      console.log(value);
      if (value.length > 0) {
        this.userForm.provinceId = "330000";
        this.userForm.cityId = value[0];
        this.userForm.districtId = value[1];
        this.userForm.unitId = value[2];
      } else {
        this.userForm.provinceId = null;
        this.userForm.cityId = null;
        this.userForm.unitId = null;
        this.userForm.districtId = null;
      }
    },

    adduser() {
      const params = {
        dept: {
          createTime: "",
          deptName: "",
          id: this.userForm.deptId,
          updateTime: ""
        },
        role: {
          createTime: "",
          id: this.userForm.roleId,
          roleKey: "",
          roleName: "",
          updateTime: ""
        },
        user: {
          certNo: this.userForm.certNo,
          createTime: "",
          id: "",
          nickname: this.userForm.realName,
          password: this.userForm.password,
          phone: this.userForm.phone,
          status: 0,
          updateTime: "",
          username: this.userForm.userName
        }
      };
      addUser(params).then(res => {
        if (res && res.code === 200) {
          this.$message.success("添加账号成功");
          // const params = {
          //   userName: localStorage.getItem("username"),
          //   content: `${localStorage.getItem("username") +
          //     "添加了一个" +
          //     this.roleoption[this.userForm.roleId] +
          //     "，其中用户名为：" +
          //     this.userForm.userName +
          //     "，单位id为：" +
          //     this.userForm.unitId +
          //     "，真实姓名为：" +
          //     this.userForm.realName +
          //     "，手机号为：" +
          //     this.userForm.phone +
          //     "，邮箱为：" +
          //     this.userForm.email}`,
          //   type: 3,
          //   operateTime: this.$moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          //   platform: 7,
          //   module: "用户管理"
          // };
          // addlogoperate(params).then(res => {
          //   console.log(res);
          // });

          this.$emit("addsuccess", true);
          this.$refs.userForm.resetFields();
          this.addVisible = false;
        }
      });
    },

    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          console.log(this.userForm);
          this.adduser();
        } else {
          return false;
        }
      });
    }
  },
  created() {}
};
</script>
<style scoped>
.el-form {
  padding: 0 20px;
}
.el-form-item {
  margin-bottom: 10px;
}

::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-select,
.el-cascader {
  width: 100%;
}
::v-deep .el-dialog__body {
  padding: 20px 0;
}
.el-dialog__footer {
  padding: 0;
}
.el-form-item__label {
  float: none;
  padding: 0;
}
</style>